import styled from 'styled-components';
import { IconArrowTop } from 'assets/icon';
import { palette } from 'styles/color';

const ScrollTopButton = ({ show, onClick }: { show: boolean; onClick: () => void }) => {
  if (!show) return null;
  return (
    <ScrollTopBtn onClick={onClick}>
      <IconArrowTop />
    </ScrollTopBtn>
  );
};

export default ScrollTopButton;

const ScrollTopBtn = styled.button`
  position: fixed;
  right: 30px;
  bottom: 40px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: ${palette.gray[700]};
  background: ${palette.white};
  border: 1px solid ${palette.gray[100]};
  box-shadow: 0px 0px 8px 0px #0000001a;
  cursor: pointer;
  z-index: 1000;
`;
